/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Default from '../../constants/defaults';
import useDropDownOpen from '../../hooks/useDropDownOpen';

const buildFilterValue = (eventTarget, type, buildFilter) => {
  if (eventTarget.type === 'button' && eventTarget.textContent === 'All') {
    buildFilter('all', type, eventTarget.value);
  } else if (eventTarget.checked) {
    buildFilter('add', type, eventTarget.value);
  } else {
    buildFilter('remove', type, eventTarget.value);
  }
};

const ValueFilterDropdown = ({
  title,
  valueOptions,
  severityOptions,
  buildFilter,
  checkedOptions,
  onFilterClick
}) => {
  const { open, setOpen } = useDropDownOpen();

  const type = title.toLowerCase();
  const displayOptions = Object.keys(valueOptions)
    .filter((key) => key <= Default.LIMIT_VRS_VALUE)
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: valueOptions[key]
      }),
      {}
    );

  const handleButtonClick = () => {
    setOpen((prevOpen) => !prevOpen);
    onFilterClick(type);
  };

  return (
    <div className={`dropdown ${open ? "open" : ""}`}>
      <button
        type="button"
        className={`btn btn-link vrs-filter ${type}`}
        onClick={handleButtonClick}
      >
        {title}
      </button>
      {open && (
        <ul
          className={`dropdown-menu ${type}`}
          onClick={(e) => e.stopPropagation()}
        >
          <form>
            <li key="unassigned-value">
              <label className="custom-checkbox">
                Blank
                <input
                  type="checkbox"
                  onChange={(event) =>
                    buildFilterValue(event.target, type, buildFilter)}
                  value="unassigned"
                  checked={checkedOptions.includes('unassigned')}
                />
                <span className="checkmark" />
              </label>
            </li>
            {Object.keys(displayOptions).map((key) => (
              <li key={`value-${key}`}>
                <label className="custom-checkbox">
                  {displayOptions[key]}
                  <input
                    id={`${type}-${key}`}
                    type="checkbox"
                    onChange={(event) =>
                      buildFilterValue(event.target, type, buildFilter)}
                    name={type}
                    value={key}
                    checked={checkedOptions.includes(key)}
                  />
                  <span className="checkmark" />
                </label>
              </li>
            ))}
            <hr />
            {Object.keys(severityOptions).map((key) => (
              <li key={`severity-${key}`}>
                <label className="custom-checkbox">
                  {severityOptions[key]}
                  <input
                    id={`${type}-${key}`}
                    type="checkbox"
                    onChange={(event) =>
                      buildFilterValue(event.target, type, buildFilter)}
                    name={type}
                    value={`severity-${key}`}
                    checked={checkedOptions.includes(`severity-${key}`)}
                  />
                  <span className="checkmark" />
                </label>
              </li>
            ))}
            <li className="center">
              <button
                type="button"
                className="btn btn-xs btn-primary"
                onClick={(event) =>
                  buildFilterValue(event.target, type, buildFilter)}
              >
                All
              </button>
            </li>
          </form>
        </ul>
      )}
    </div>
  );
};

ValueFilterDropdown.propTypes = {
  title: PropTypes.string,
  options: PropTypes.object,
  checkedOptions: PropTypes.array,
  buildFilter: PropTypes.func
};

ValueFilterDropdown.defaultProps = {
  options: {
    1: 'Very Low',
    2: 'Low',
    3: 'Medium',
    5: 'High',
    8: 'Extreme'
  },
  checkedOptions: []
};

export default ValueFilterDropdown;
